<template>
    <BCard
      bg-variant="light" 
      footer-bg-variant="light" 
      class="rounded-0">
      <BRow class="align-items-center flex-nowrap w-100">
          <BCol cols="auto">
              <div class="text-info">
                  <Bot/>
              </div>
          </BCol>
          
          <BCol class="px-2" style="flex: 1 1 auto; min-width: 0;">
              <BFormInput
              class="w-100"
              :placeholder="$t('Webportal.LoopAi.AskQuestion')"
              v-model="prompt"
              @keyup.enter="submitAi"
              :disabled="isWaitingForAIResponse"
              />
          </BCol>
          <BCol cols="auto">
              <BButton size="sm" variant="primary" @click="submitAi" :disabled="isWaitingForAIResponse">
                  <i class="fa fa-paper-plane"></i>
              </BButton>
          </BCol>
      </BRow>
    </BCard>
</template>
<script>
import CustomCard from '@/componentsv3/CustomCard.vue';
import { Bot } from 'lucide-vue-next';

export default {
  name: 'ChatComposer',
  components: {
    CustomCard,
    Bot,
  },
  props: {
    isWaitingForAIResponse: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['submit'],
  data() {
    return {
      prompt: '',
      warning: '',
    };
  },
  methods: {
    submitAi() {
      if (this.prompt === '') return;

      this.$emit('submit', this.prompt);
      this.prompt = '';
    },
  },
};
</script>
